module.exports = __webpack_public_path__ + "static/media/VectorPointConcluido15.1d84fc82.svg";